import React, { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";
import CreateRequestButton from "../../components/CreateRequestButton";
import { AiOutlineFilter } from "react-icons/ai";

import { ExportRepairTools } from "./export-repair-tools";
import moment, { Moment } from "moment";
import { requestApprovalStatusNotIsDemandOptions } from "../types";
import { compareRequestStatus } from "../../utils";
import { useRepairToolsRequests } from "./hooks";
import { useRepairToolColumns } from "./hooks/use-repair-tool-columns";
import { Table, UserManual } from "../../../../components";

export const procedureRepairTools: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { columns } = useRepairToolColumns();
  const {
    mappedRepairToolsMyRequests,
    mappedRepairToolsRequests2 = [],
    isLoading,
    guideLink,
  } = useRepairToolsRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedRepairToolsRequests2];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedRepairToolsRequests2]);

  const flattedData = mappedRepairToolsRequests2.map((record: any) => ({
    id: record.id,
    createdDateTime: getDDMMYYYFormat(record.createdDateTime),
    createBy: record.createdByName,
    eDepartment: record.eDepartment,
    eUnitRoom: record.eUnitRoom,
    eUnion: record.eUnion,
    ECodeTCSSId: record.ECodeTCSSId,
    eDeviceLocation: record.eDeviceLocation,
    eBrokenDate: getDDMMYYYFormat(record.eBrokenDate),
    eDayOfIncrease: record.eDayOfIncrease,
    eCost: record.eCost,
    eResidualValue: record.eResidualValue,
    eNumEditsInYear: record.eNumEditsInYear,
    eLastEdit: record.eLastEdit,
    eCorruptedSymptoms: record.eCorruptedSymptoms,
    ePriority: record.ePriority,
    eCause: record.eCause,
    eRepair: record.eRepair,
    eRequestStatus: record.eRequestStatus,
    eRequestStatusText: requestApprovalStatusNotIsDemandOptions.find((e) => e.value === record.eRequestStatus)?.label,
  }));

  return (
    <div className="ITRepairGrantedPage">
      <div className="pd15">
        <UserManual title="SỬA CHỮA CNTT" icon={<Icon.ToolFills />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton onClick={() => history.push(Routes.createRepairTools.path.replace(":id", "0"))} />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={mappedRepairToolsMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.repairITToolDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportRepairTools
              exportContent={{
                fileName: "Danh sach yeu cau can duyet sua chua CNTT",
                content: [
                  { header: "Mã yêu cầu", dataIndex: "id" },
                  { header: "Người yêu cầu", dataIndex: "createBy" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnitRoom" },
                  { header: "Đội/Tổ", dataIndex: "eUnion" },
                  { header: "Mã TS/CC", dataIndex: "ECodeTCSSId" },
                  { header: "Vị trí thiết bị", dataIndex: "eDeviceLocation" },
                  { header: "Ngày hỏng", dataIndex: "eBrokenDate" },
                  { header: "Ngày tăng", dataIndex: "eDayOfIncrease" },
                  { header: "Nguyên giá", dataIndex: "eCost" },
                  { header: "Giá trị còn lại", dataIndex: "eResidualValue" },
                  { header: "Lần sửa trong năm", dataIndex: "eNumEditsInYear" },
                  { header: "Lần sửa gần nhất", dataIndex: "eLastEdit" },
                  {
                    header: "Hiện tượng hỏng",
                    dataIndex: "eCorruptedSymptoms",
                  },
                  { header: "Độ ưu tiên", dataIndex: "ePriority" },
                  { header: "Nguyên nhân", dataIndex: "eCause" },
                  { header: "Phương án đề xuất", dataIndex: "eRepair" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestApprovalStatusNotIsDemandOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportRepairTools>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.repairITToolDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
